import React from 'react'
import DnDFlow from './components/Flow'
import Savebutton from './components/Savebutton'

const App = () => {
  return (
    <div style={{height:"100vh"}}>
      <Savebutton/>
      <DnDFlow/>
    </div>
  )
}

export default App
